<template>

<app-content :loading="is.loading">

	<app-content-head title="Overview" subtitle="See an overview of your revenue and payouts." />

	<app-content-body v-if="!is.loading">

		<app-content-summary>

			<app-content-summary-item label="Sales" :is-metric="true" :no-plural="true" :value="$org.tracking.billing.transactions.payments | formatMoney" />

			<app-content-summary-item graph="sparkline" :value="data.sales" :grow="true" :is-end="true" />

			<app-content-summary-item label="Net Revenue" :is-metric="true" :no-plural="true" :value="$org.tracking.billing.net | formatMoney" :is-start="true" :is-end="true" />

			<app-content-summary-item label="Paid Out" theme="blue" :is-start="true" :is-metric="true" :no-plural="true" :value="$org.tracking.billing.payouts.total | formatMoney" :link="{name: 'Organisation.Billing.Payouts'}" />

		</app-content-summary>

		<app-content-box title="Monthly Sales">

			<app-graph type="stacked" :data="data.channels.data" :options="data.channels.options" class="graph" />

		</app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {
			is: {
				loading: true
			},
			data: {}
		}
	},

	created: function() {
	
		this.load()

	},

	methods: {

		load: function() {

			this.$api.get('organisation/billing/overview').then(function(json) {

				Vue.set(this, 'data', json.data)

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.graph {
	height: 320px;
}

</style>